import React from 'react';
import { Radio, DatePicker, Space, Form } from 'antd';
import type { RadioChangeEvent } from 'antd';
import type { Dayjs } from 'dayjs';
import { ScheduleType } from '../../../schemas';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import { updateWorkflowCreatePayload } from '../../../store/workflows/slice';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

const formItemStyle: React.CSSProperties = {
  border: '1px solid #F4F4F4',
  background: '#FFFFFF',
  borderRadius: 20,
  padding: 16,
};

const JobTypeAndScheduling = () => {
  const dispatch = useAppDispatch();
  const workflowPayload = useAppSelector(state => state.workflows.workflowCreatePayload);

  const handleJobTypeChange = (e: RadioChangeEvent) => {
    const newJobType = e.target.value as ScheduleType;
    dispatch(
      updateWorkflowCreatePayload({
        scheduleType: newJobType,
      }),
    );

    if (newJobType !== 'SCHEDULED') {
      dispatch(
        updateWorkflowCreatePayload({
          scheduleStartTime: undefined,
          scheduleEndTime: undefined,
        }),
      );
    }
  };

  const handleStartTimeChange = (date: Dayjs | null) => {
    dispatch(
      updateWorkflowCreatePayload({
        scheduleStartTime: date ? date.utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : undefined,
      }),
    );
  };

  const handleEndTimeChange = (date: Dayjs | null) => {
    dispatch(
      updateWorkflowCreatePayload({
        scheduleEndTime: date ? date.utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : undefined,
      }),
    );
  };

  const isScheduled = workflowPayload?.scheduleType === 'SCHEDULED';

  return (
    <Form layout="vertical" requiredMark={false}>
      <Form.Item label="Job Type" required style={formItemStyle}>
        <Radio.Group
          value={workflowPayload?.scheduleType || 'ONGOING'}
          onChange={handleJobTypeChange}
        >
          <Space direction="vertical">
            <Radio value="ONGOING">On Going</Radio>
            <Radio value="SCHEDULED">Scheduled</Radio>
            <Radio value="ONE_TIME">One Time</Radio>
          </Space>
        </Radio.Group>
      </Form.Item>

      {isScheduled && (
        <>
          <Form.Item label="Start Time" required style={formItemStyle}>
            <DatePicker
              showTime
              placeholder="Select start date and time"
              value={
                workflowPayload?.scheduleStartTime ? dayjs(workflowPayload.scheduleStartTime) : null
              }
              onChange={handleStartTimeChange}
              style={{
                width: '100%',
                border: '1px solid #F4F4F4',
                borderRadius: 8,
              }}
              format="YYYY-MM-DD HH:mm:ss"
            />
          </Form.Item>

          <Form.Item label="End Time" required style={formItemStyle}>
            <DatePicker
              showTime
              placeholder="Select end date and time"
              value={
                workflowPayload?.scheduleEndTime ? dayjs(workflowPayload.scheduleEndTime) : null
              }
              onChange={handleEndTimeChange}
              style={{
                width: '100%',
                border: '1px solid #F4F4F4',
                borderRadius: 8,
              }}
              format="YYYY-MM-DD HH:mm:ss"
              disabledDate={current => {
                if (!workflowPayload?.scheduleStartTime || !current) {
                  return false;
                }
                return current.isBefore(dayjs(workflowPayload.scheduleStartTime), 'day');
              }}
            />
          </Form.Item>
        </>
      )}
    </Form>
  );
};

export default JobTypeAndScheduling;
